<template>
  <div class="Package">
    <div class="acc">
      <el-row>
        <el-button type="primary" @click="addpackage">创建套餐</el-button>

        <el-input class="search" placeholder="搜索功能关键字" prefix-icon="el-icon-search" v-model="input2">
        </el-input>

        <el-button class="search_btn" @click="sousuo" type="primary">搜索</el-button>
      </el-row>
    </div>

    <ul class="Package_list">
      <li v-for="item in list" :key="item.DicID">
        <img :src="item.CoverUrl" alt="" />
        <h3>{{ item.SetMealName }}</h3>
        <p class="iji" :title="item.DescribeS">{{ item.DescribeS }}</p>

        <el-row>
          <el-button @click="del(item.SetMealID)">删除</el-button>
          <el-button @click="editor(item.SetMealID)" type="primary" plain>编辑</el-button>
          <el-button @click="push" type="primary">推送测试</el-button>
        </el-row>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  data() {
    return {
      input2: '',
      list: '',
    }
  },
  methods: {
    del(code) {
      this.$Http_Post('ScaleIssue/DePaperSetmeal', {
        SetMealID: code,
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          let svs = this.list
          this.list.forEach(function (value, index, array) {
            if (code == array[index].SetMealID) {
              svs.splice(index, 1)
            }
          })
          this.$notify({
            title: '成功',
            message: '删除成功',
            type: 'success',
          })
        } else {
          this.$notify.error({
            title: '错误',
            message: res.data.Message,
          })
        }
      })
    },
    addpackage() {
      this.$router.push('addpackage')
    },
    create() {
      alert('创建副本')
    },
    editor(code) {
      //点击编辑
      this.$router.push({
        path: 'Modifypackage',
        query: { code: code },
      })
    },
    push() {
      alert('推送测试')
    },
    sousuo() {
      this.loading(this.input2)
    },

    loading(val) {
      this.$Http_Post('ScaleIssue/GetPaperSetmeal', {
        Condition: val,
        pageSize: '12',
        pageIndex: '1',
      }).then((res) => {
        if (res.Code == 200 || res.Code == 0) {
          this.list = res.Data.Lists
        } else {
        }
      })
    },
  },
  mounted() {
    this.loading('')
  },
}
</script>
<style>
.acc {
  height: 50px;
  position: relative;
}

.search {
  width: 240px;
  position: absolute;
  top: 0px;
  right: 90px;
}

.search input {
  background-color: rgba(242, 242, 242, 1);
}

.search_btn {
  position: absolute;
  top: 0px;
  right: 0px;
}

.Package_list {
  padding: 10px;
  height: 100%;
}

.Package_list li {
  float: left;
  width: 31%;
  margin-right: 2%;
  height: 160px;
  margin-top: 20px;
  border-radius: 10px;
  position: relative;
  margin-bottom: 10px;
}

.Package_list li img {
  width: 102px;
  height: 76px;
  position: absolute;
  top: 15px;
  left: 15px;
}

.Package_list li h3 {
  color: rgba(61, 61, 61, 1);
  font-size: 16px;
  position: absolute;
  top: 15px;
  left: 140px;
}

.Package_list li p {
  color: rgba(107, 107, 107, 1);
  font-size: 13px;
  position: absolute;
  left: 140px;
  top: 50px;
}

.Package_list .el-row {
  position: absolute;
  bottom: 0px;
  margin-bottom: 15px;
  right: 15px;
}

.Package_list .el-row button {
  padding: 8px 10px;
}

.Package_list li:hover {
  box-shadow: 0 0 15px 0 rgb(0 0 0 / 31%);
}

.iji {
  display: -webkit-box;
  height: 60px;
  overflow: hidden;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  height: 36px;
}
</style>
